import { Helmet } from 'react-helmet';
import { useEffect } from 'react';
import { pageView } from '../../scripts/analytics';

import PageLayout from '../../layouts/PageLayout';
import Header from '../../components/blocks/Header';
import Heading from '../../components/blocks/Heading';
import Textblock from '../../components/blocks/Textblock';

import topVisual from '../../assets/images/frontpage-top-2.jpg';
import kpnImg from '../../assets/images/partners-kpn.jpg';
import loterijImg from '../../assets/images/partners-loterij.jpg';
import unibetImg from '../../assets/images/partners-unibet.jpg';
import sportdirectImg from '../../assets/images/partners-sportdirect.jpg';
import eaImg from '../../assets/images/partners-ea.jpg';
import digitalEnterpriseImg from '../../assets/images/partners-digital-enterprise.jpg';
import aragImg from '../../assets/images/partners-arag.jpg';
import radio538Img from '../../assets/images/partners-538.jpg';

const Partners = () => {
    useEffect(() => {
        pageView('partners');
    }, []);

    return (
        <PageLayout>
            <Helmet>
                <title>ESPN - Kijk alle Eredivisie wedstrijden live!</title>
                <meta
                    name="description"
                    content="Wil je niks meer missen van de Eredivisie? Neem ESPN Compleet en kijk alle wedstrijden live."
                />
                <meta
                    property="og:title"
                    content="ESPN - Kijk alle Eredivisie wedstrijden live!"
                />
                <meta
                    property="og:description"
                    content="Wil je niks meer missen van de Eredivisie? Neem ESPN Compleet en kijk alle wedstrijden live."
                />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={topVisual} />
            </Helmet>
            <Header
                image={topVisual}
                title="Eredivisie Partners"
                buttons={[
                    {
                        label: 'Bekijk onze Partners',
                        link: '#partners',
                        type: 'primary',
                        size: 'large',
                    },
                ]}
            />
            <div id="partners" />
            <Textblock
                title="Maatschappelijk partner Eredivisie"
                text={
                    <>
                        Sinds 2005 is de VriendenLoterij maatschappelijk partner
                        van de Eredivisie. Samen zetten we ons in om fondsen te
                        werven voor maatschappelijke projecten die bijdragen aan
                        een gezonde en sterke samenleving. Je kunt zelf ook
                        meespelen voor jouw favoriete eredivisieclub. Zo gaat
                        minimaal 40 procent van jouw lot naar maatschappelijke
                        projecten van jouw eredivisieclub.
                    </>
                }
                image={loterijImg}
                imgLink="www.vriendenloterij.nl"
                imgAlt="de VriendenLoterij"
                imgSize={30}
                revert={true}
            />

            <Textblock
                title="Hoofdsponsor Eredivisie"
                text={
                    <>
                        Vanaf het seizoen 2017-2018 is KPN de Hoofdsponsor van
                        de Eredivisie. KPN was al sinds 2014 een official
                        partner van de hoogste Nederlandse voetbalcompetitie en
                        in het verleden ook al hoofdsponsor van de Eredivisie,
                        van 1990 tot en met 2002. Het oer-Hollandse bedrijf met
                        telecommunicatie- en ICT-diensten wil graag de komende
                        jaren een positieve bijdrage aan het voetbal leveren.
                        KPN staat voor verbinding. En verbinding maak je samen!
                    </>
                }
                image={kpnImg}
                imgLink="www.kpn.nl"
                imgAlt="KPN"
                imgSize={30}
                revert={true}
            />

            <Textblock
                title="Official Betting Partner "
                text={
                    <>
                        Unibet is Official Betting Partner van de Eredivisie &
                        ESPN. Unibet is opgericht in 1997 en maakt deel uit van
                        Kindred Group, één van ’s werelds grootste
                        beursgenoteerde online kansspelaanbieders met 9 merken
                        in het portfolio. Unibet heeft een vergunning voor het
                        aanbieden van online kansspelen in Nederland. Spelers
                        kunnen via Unibet onder meer op een breed scala aan
                        sportwedstrijden wedden en exclusieve online casino
                        spellen spelen.
                    </>
                }
                image={unibetImg}
                imgLink="https://www.unibet.nl/betting/sports/filter/football/netherlands/eredivisie"
                imgAlt="Unibet"
                imgSize={30}
                revert={true}
            />

            <Textblock
                title="Official Supplier Eredivisie"
                text={
                    <>
                        Sportdirect is onderdeel van Deventrade BV en het enige
                        officiële online verkooppunt in Nederland van Derbystar,
                        sinds 2006 de officiële Eredivisie wedstrijdbal.
                        Sportdirect.com werkt nauw samen met vele
                        sportspeciaalzaken in Nederland, waardoor alle artikelen
                        altijd te passen zijn en advies nooit ver weg is. Door
                        de aanwezigheid in de sportspeciaalzaken en online wordt
                        iedere sportliefhebber op zijn wenken bediend.
                    </>
                }
                image={sportdirectImg}
                imgLink="https://www.sportdirect.com/nl/"
                imgAlt="Sportdirect"
                imgSize={30}
                revert={true}
            />
            <Textblock
                title="Official Media Supplier"
                text={
                    <>
                        Sinds seizoen 2023-2024 is Radio 538 Official Media
                        Supplier van de Eredivisie. Radio 538 is sinds 1992 dé
                        hitzender van Nederland. Het radiostation brengt de hits
                        van nu en voert het gesprek van de dag: altijd opgewekt
                        en met een lach. Radio 538 is er voor iedereen die
                        altijd jong wil blijven, niks wil missen en alles uit
                        het leven wil halen. Nooit voorspelbaar, altijd
                        herkenbaar. Bekende programma’s van het radiostation
                        zijn De 538 Ochtend met Tim, Rick, Niels en Florentien,
                        De 538 Middag met Frank en De Coen en Sander Show.
                    </>
                }
                image={radio538Img}
                imgLink="https://www.538.nl"
                imgAlt="Radio 538"
                imgSize={30}
                revert={true}
            />
            <Heading size="large" theme="dark" background="dark">
                ESPN Partners
            </Heading>
            <Textblock
                title="Official Partnership"
                text={
                    <>
                        Digital Enterprises heeft sinds het seizoen 2020-2021
                        een partnership met ESPN. Met een bereik van 12 miljoen
                        unieke bezoekers per maand is Digital Enterprises de
                        grootste uitgever op het gebied van mannen en sport. Met
                        Voetbal International, VoetbalPrimeur.nl en GPblog.com
                        heeft Digital Enterprises een ongeëvenaarde
                        zichtbaarheid bij de doelgroep, zowel online als print.
                    </>
                }
                image={digitalEnterpriseImg}
                imgSize={30}
                imgAlt="Digital Enterprises"
                revert={true}
            />
            <Textblock
                title="Official Partnership"
                text={
                    <>
                        ARAG is official partner van de KNVB scheidsrechters
                        betaald voetbal. Samen met de KNVB wil ARAG werken aan
                        het bevorderen van fair play. Daarbij richten beide
                        partijen zich niet alleen op de Eredivisie, maar juist
                        ook op het amateurvoetbal. ESPN draagt middels haar
                        social kanalen en de serie Extra Tijd bij aan dit
                        partnership.
                    </>
                }
                image={aragImg}
                imgAlt="ARAG"
                imgSize={30}
                revert={true}
            />
            <Textblock
                title="Official Partnership"
                text={
                    <>
                        Samen met EA zet ESPN haar kanalen in voor verschillende
                        campagnes rondom EA FC. EA FC is een platform dat
                        miljoenen fans online verbindt door middel van eSports
                        en innovatie.
                    </>
                }
                image={eaImg}
                imgAlt="EA"
                imgSize={30}
                revert={true}
            />
        </PageLayout>
    );
};

export default Partners;
